import React, { createContext, useContext, useState } from 'react';

const EditTagsSearchContext = createContext();

export const useEditTagsSearch = () => {
  const context = useContext(EditTagsSearchContext);
  if (!context) {
    throw new Error('useEditTagsSearch must be used within an EditTagsSearchProvider');
  }
  return context;
};

export const EditTagsSearchProvider = ({ children, onSearchPerformed }) => {
  const [searchTerm, setSearchTerm] = useState('');

  // The search box shows what was typed (ENG-508): storing the trimmed
  // value swallowed a trailing space as it was typed, so "hey jude" typed
  // key by key became "heyjude". Matching trims instead.
  const performSearch = (term) => {
    const trimmedTerm = term.trim();
    setSearchTerm(term);
    
    // Notify parent when a search is performed with actual content
    if (trimmedTerm && onSearchPerformed) {
      onSearchPerformed();
    }
  };

  const clearSearch = () => {
    setSearchTerm('');
  };

  const value = {
    searchTerm,
    performSearch,
    clearSearch,
  };

  return (
    <EditTagsSearchContext.Provider value={value}>
      {children}
    </EditTagsSearchContext.Provider>
  );
};